import { getAnnotation, getTemplate } from '@/mgnl/utils/magnolia.js';
import { EditorContextService, Constants } from '@magnolia/frontend-helpers-base';
import { defineElement, TemplateElement } from '@webtides/element-js';
import { isObjectLike } from '@webtides/element-js/src/util/AttributeParser';

class MgnlEditableComponent extends TemplateElement {
    properties() {
        return {
            content: null,
            tagName: 'magnolia-fallback-component',
        };
    }

    injectProperties() {
        return { config: null, mgnlContext: null, templateAnnotations: null };
    }

    async connected() {
        this.updateElement();
    }

    updateElement() {
        const component = this.config?.componentMappings?.[getTemplate(this.content)];

        // assume config to be either an object or a string
        this.tagName = component?.tagName ?? component ?? 'magnolia-fallback-component';
        // this needs to be updated!
        this._element = document.createElement(this.tagName);
        if (isObjectLike(component) && component?.spread === true) {
            Object.assign(this._element, { ...this.content });
        } else {
            this._element.content = this.content;
        }
    }

    beforeUpdate() {
        super.beforeUpdate();
        this.updateElement();
    }
    get annotation() {
        return getAnnotation(this.templateAnnotations, this.content);
    }

    renderTemplate() {
        const container = this.getRoot();

        while (container.firstChild) {
            container.removeChild(container.firstChild);
        }
        const fragment = document.createDocumentFragment();

        if (this.annotation) {
            const comment = document.createComment(this.annotation);
            fragment.appendChild(comment);
            EditorContextService.refresh(0);
        }

        this.updateElement();
        fragment.appendChild(this._element);

        if (this.annotation) {
            const comment = document.createComment(Constants.END_AREA_COMMENT);
            fragment.appendChild(comment);
        }

        container.appendChild(fragment);
    }
}

defineElement('mgnl-editable-component', MgnlEditableComponent);
